import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHpComponent } from './simple-icons-hp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHpComponent ],
    exports:      [ SimpleIconsHpComponent ],
    bootstrap:    []
})
export class SimpleIconsHpModule {}
